import React, { useState } from "react";
import { Modal, Input, notification, Checkbox, Space, Form, Tabs } from "antd";
import { FileTextOutlined } from "@ant-design/icons";

import axiosInstance from "utilities/axios";
import { EquipmentSelectorOrderable } from "components/EquipmentSelector";
import TransferRequest from "./TransferRequest";

const { TextArea } = Input;

function RequestEquipment({ isVisible, onClose, onAdd, clinicNo }) {
  const [form] = Form.useForm();
  const [activeTabKey, setActiveTabKey] = useState("1");
  const [loading, setLoading] = useState(false);

  const handleSubmit = (values) => {
    setLoading(true);
    const payload = {
      clinicNo,
      ...values,
      equipmentId: activeTabKey === "1" ? values.equipmentId : undefined,
      equipmentItemId:
        activeTabKey === "2" ? values.equipmentItemId : undefined,
      type: activeTabKey === "1" ? "New Equipment" : "Transfer",
    };

    axiosInstance
      .post("/equipment/requests", payload)
      .then(() => {
        notification.success({
          message: "Equipment Request Submitted",
          description: "Your request has been submitted for review.",
        });
        onAdd();
        onClose();
        form.resetFields();
      })
      .catch((error) => {
        console.log(payload);
        notification.error({
          message: "Error",
          description: error.message,
        });
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <Modal
      title="Request Equipment"
      open={isVisible}
      onCancel={() => {
        onClose();
        form.resetFields();
      }}
      style={{ top: 30 }}
      okText="Submit Request"
      okButtonProps={{ loading }}
      onOk={() => {
        form.submit();
      }}
    >
      <Form form={form} onFinish={handleSubmit} layout="vertical">
        <Tabs
          defaultActiveKey="1"
          onChange={(key) => setActiveTabKey(key)}
          items={[
            {
              key: "1",
              label: "Request Equipment",
              children: (
                <Form.Item name="equipmentId" label="Equipment Type">
                  <EquipmentSelectorOrderable />
                </Form.Item>
              ),
            },
            {
              key: "2",
              label: "Transfer Equipment",
              children: (
                <Form.Item name="equipmentItemId">
                  <TransferRequest />
                </Form.Item>
              ),
            },
          ]}
        />
        <Form.Item
          name="comments"
          label={
            <Space>
              <FileTextOutlined /> Comments for Reviewer
            </Space>
          }
        >
          <TextArea rows={2} autoSize={{ minRows: 2, maxRows: 4 }} />
        </Form.Item>
        <Form.Item name="trainingRequested" valuePropName="checked">
          <Checkbox>Request Training</Checkbox>
        </Form.Item>
      </Form>
    </Modal>
  );
}

export default RequestEquipment;
